import React from 'react';
import { GiBilledCap } from 'react-icons/gi';
import './Header.css';
const Header = () => {
    return (
        <div className='header'>
            <GiBilledCap className='icon-left'></GiBilledCap>
            <h1>Cap Collection</h1>
            <GiBilledCap className='icon-right'></GiBilledCap>
        </div>
    );
};

export default Header; <h2>hello</h2>